import { render, staticRenderFns } from "./ReturnPartsItemList.vue?vue&type=template&id=30452e50"
import script from "./ReturnPartsItemList.vue?vue&type=script&lang=js"
export * from "./ReturnPartsItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30452e50')) {
      api.createRecord('30452e50', component.options)
    } else {
      api.reload('30452e50', component.options)
    }
    module.hot.accept("./ReturnPartsItemList.vue?vue&type=template&id=30452e50", function () {
      api.rerender('30452e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnparts/ReturnPartsItemList.vue"
export default component.exports